<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Alert } from '@Shelly/shelly-design-system/index';
	import { getDeviceStatus } from 'src/stores/device-runtime/status-selectors';
	//Types
	import type { Device } from 'src/types/Device';

	export let device: Device;

	$: statusStore = getDeviceStatus(device.id);
	$: autoBalanceError = ($statusStore?.[`service:0`]?.errors || []).find((i) =>
		/^(auto_balance_timeout|auto_balance_em_not_found)$/.test(i),
	);
</script>

{#if autoBalanceError}
	<Alert
		class="mb-s"
		type="danger"
		heading={autoBalanceError === 'auto_balance_timeout'
			? $format('notification_error_auto_balance_timeout', {
					default: 'Auto balance is active and the configured Shelly EM can not be reached.',
				})
			: $format('notification_error_auto_balance_em_not_found', {
					default: 'Auto balance is active and configured ip is not Shelly EM device.',
				})}
	/>
{/if}
